import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default function usePagination(store, key, actionEmitter) {
	const dispatch = useDispatch();
	const storeData = useSelector((state: any) => state[store]);
	const keyData = storeData?.[key] || {};
	const filter = keyData.filter || {};

	const {
		searchText = '',
		page = 0,
		pageSize = 50,
		sortModel = [],
		onlyShowUnused = false,
		folders = [],
		where = {},
	} = filter;

	const setSearchText = useCallback(
		(newSearchText) => {
			dispatch(actionEmitter({ searchText: newSearchText }));
		},
		[dispatch, actionEmitter]
	);

	const setSortModel = useCallback(
		(newSortModel) => {
			dispatch(actionEmitter({ sortModel: newSortModel }));
		},
		[dispatch, actionEmitter]
	);

	const setPage = useCallback(
		(newPage) => {
			dispatch(actionEmitter({ page: newPage }));
		},
		[dispatch, actionEmitter]
	);

	const setPageSize = useCallback(
		(newPageSize) => {
			dispatch(actionEmitter({ pageSize: newPageSize }));
		},
		[dispatch, actionEmitter]
	);

	const setFolders = useCallback(
		(newFolders) => {
			dispatch(actionEmitter({ folders: newFolders }));
		},
		[dispatch, actionEmitter]
	);

	const setWhere = useCallback(
		(newWhereFilter) => {
			dispatch(actionEmitter({ where: newWhereFilter }));
		},
		[dispatch, actionEmitter]
	);

	const setOnlyShowUnused = useCallback(
		(newValue) => {
			dispatch(actionEmitter({ onlyShowUnused: newValue }));
		},
		[dispatch, actionEmitter]
	);

	const usersFilter = {
		searchText,
		order: (sortModel && sortModel[0]?.field) || undefined,
		direction: (sortModel && sortModel[0]?.sort) || undefined,
		page: page,
		take: pageSize,
		where,
	};

	const clientsFilter = {
		searchText,
		order: (sortModel && sortModel[0]?.field) || undefined,
		direction: (sortModel && sortModel[0]?.sort) || undefined,
		page: page,
		take: pageSize,
		where,
	};

	return {
		searchText,
		setSearchText,
		sortModel,
		setSortModel,
		page,
		setPage,
		pageSize,
		setPageSize,
		onlyShowUnused,
		setOnlyShowUnused,
		folders,
		setFolders,
		where,
		setWhere,
		usersFilter,
		clientsFilter,
	};
}
